import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { LogEntry } from 'src/app/core/models/common/log-entry.model';
import { environment } from 'src/environments/environment';
import { IApiResponse } from '../../interfaces/api/api-response.interface';
import { IAppState } from '../../store/common/interfaces/app-state.interface';
import { applyUserProfileId } from '../../ui-helpers/functions/user-context-url.func';

@Injectable()
export class LoggerService {
  private apiUrl = environment.apiUrl;
  private controllerSuffix = 'Onboarding/Onboarding/';

  constructor(
    private httpClient: HttpClient,
    private store: Store<IAppState>,
  ) {}

  async info(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, 'info', optionalParams);
  }

  async warn(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, 'warn', optionalParams);
  }

  async error(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, 'error', optionalParams);
  }

  async fatal(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, 'fatal', optionalParams);
  }

  async log(msg: string, ...optionalParams: any[]) {
    this.info(msg, optionalParams);
  }

  private async writeToLog(
    msg: string,
    logType: 'error' | 'info' | 'warn' | 'fatal',
    params: any[],
  ) {
    this.publish(new LogEntry(msg, logType, params));
  }

  private async publish(entry: LogEntry) {
    let params = new HttpParams();
    params = applyUserProfileId(params, this.store);
    const url = `${this.apiUrl}${this.controllerSuffix}ui-log`;
    const res = firstValueFrom(
      this.httpClient.post<IApiResponse>(url, entry, { params }),
    );
    return res;
  }
}
